<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div style="display: flex;justify-content: space-between">
        <input-select selectTitle="账单类型" :selectKey="'billType'" :selectData="billTypeList" @search="search"/>
        <input-select :selectTitle="'缴费方式'" style="margin: 0 10px;" :selectKey="'paymentMethod'" :selectData="payPatternList" @search="search"  />
          <span style="display: inline-block;color: #48576a;;margin-right: 5px;">收款日期</span>
          <el-date-picker v-model="timevalue"  size="small" type="datetimerange" range-separator="至"
                          start-placeholder="开始日期" end-placeholder="结束日期"
                          align="right" value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
      </div>
        <div class="btn-box">
        </div>
      <div style="display: flex;justify-content: flex-end;">
      <input-search placeholder="车牌号/车主姓名/经办人姓名" @search="searchKey" />
      <button-export style="margin-left: 10px;" :href="exportUrl" download="download.xls" :beforeDownload="beforeDownload" value="导出" v-if="permissionCodes.indexOf('004011001') !== -1"/>
      </div>
    </div>
    <table-main :selection="false" :hasOperation="false" :tableHead="tableHead" :tableData="tableData" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" />
    </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import ButtonAdd from "../../../components/Button/ButtonAdd";
import ButtonDelete from "../../../components/Button/ButtonDelete";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import InputSearch from "../../../components/Input/InputSearch";
import InputSelect from "../../../components/Input/InputSelect";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/ParkingService";
import { errorHandler } from "../../../utils/errorHandler";
import { nAlert, nSuccess } from "../../../utils/notice";
import { bus } from "../../../utils/bus";

export default {
  components: {
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    ButtonAdd,
    Breadcrumb
  },
  name: "parking-month-bill",
  data() {
    return {
      permissionCodes: "",
      breadcrumb: [
        {
          value: "智慧停车",
          name: "parking-device-management"
        },
        {
          value: "包月账单"
        }
      ],
      tableHead: [
        {
          prop: "carNumber",
          label: "车牌号"
        },
        {
          prop: "lotNumber",
          label: "车位号"
        },
        {
          prop: "carOwnerName",
          label: "车主姓名"
        },
        {
          prop: "billTypeText",
          label: "账单类型"
        },
        {
          prop: "unitPrice",
          label: "包月展示金额"
        },
        {
          prop: "money",
          label: "实际金额"
        },
        {
          prop: "payTime",
          label: "收款日期"
        },
        {
          prop: "operateTime",
          label: "操作时间"
        },
        {
          prop: "operator",
          label: "经办人姓名"
        },
        {
          prop: "enterpriseName",
          label: "承租主体"
        },
        {
          prop: "paymentMethodText",
          label: "缴费方式"
        },
        {
          prop: "cycle",
          label: "账单区间"
        }
      ],
      billTypeList: [
        {
          key: "",
          label: "全部"
        },
        {
          key: "1",
          label: "新增"
        },
        {
          key: "2",
          label: "续费"
        },
        {
          key: "3",
          label: "退费"
        }
      ],
      payPatternList: [],
      pageSize: 10,
      pageNum: 1,
      total: 0,
      tableData: [],
      selectionArr: [],
      exportUrl: "",
      requestData: {
        searchKey: "",
        billTypeText: "",
        billType: "",
        paymentMethod: "",
        startTime: "",
        endTime: ""
      },
      timevalue: []
    };
  },
  created() {
    this.getPage();
    this.getList();
    this.permissionCodes = bus.global.permissionCodes;
  },
  activated() {
    this.getPage();
  },
  methods: {
    beforeDownload() {
      this.exportUrl = `${api.exportParkingMonthBill}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&searchKey=${
        this.requestData.searchKey
      }&billType=${this.requestData.billType}&startTime=${
        this.requestData.startTime
      }&endTime=${this.requestData.endTime}&paymentMethod=${
        this.requestData.paymentMethod
      }`;
    },
    getPage() {
      if (this.timevalue) {
        this.requestData.startTime = this.timevalue[0] || "";
        this.requestData.endTime = this.timevalue[1] || "";
      } else {
        this.requestData.startTime = "";
        this.requestData.endTime = "";
      }
      let reqData = this.requestData;
      reqData.pageNum = this.pageNum;
      reqData.pageSize = this.pageSize;
      this.$axios
        .post(api.getParkingMonthBillPage, reqData)
        .then(res => {
          console.log(res);
          let data = res.data.data.list;
          data.map(v => {
            if (v.billType == "1") {
              v.billTypeText = "新增";
            } else if (v.billType == "2") {
              v.billTypeText = "续费";
            } else {
              v.billTypeText = "退费";
            }
            if (v.paymentMethod == "1") {
              v.paymentMethodText = "月付";
            } else if (v.paymentMethod == "2") {
              v.paymentMethodText = "季付";
            } else if (v.paymentMethod == "3") {
              v.paymentMethodText = "半年付";
            } else {
              v.paymentMethodText = "年付";
            }
          });
          this.total = res.data.data.total;
          this.tableData = data;
        })
        .catch(errorHandler("获取包月账单失败"));
    },
    changePagination(data) {
      this.pageNum = data[0];
      this.pageSize = data[1];
      this.getPage();
    },
    searchKey(v) {
      this.pageNum = 1;
      this.requestData.searchKey = v;
      this.getPage();
    },
    search(v) {
      this.pageNum = 1;
      this.requestData[v.key] = v.value;
      this.getPage();
    },
    getList() {
      this.$axios
        .post(api.getParkingPaymentConfigList, {
          configType: 2
        })
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            data.map(v => {
              if (v.paymentCycle === "1") {
                v.paymentCycleText = "月付";
              } else if (v.paymentCycle === "2") {
                v.paymentCycleText = "季付";
              } else if (v.paymentCycle === "3") {
                v.paymentCycleText = "半年付";
              } else if (v.paymentCycle === "4") {
                v.paymentCycleText = "年付";
              }
              v.key = v.paymentCycle;
              v.label = v.paymentCycleText;
            });
            data.unshift({ key: "", label: "全部" });
            this.payPatternList = data;
          }
        })
        .catch(errorHandler("获取配置数据失败"));
    }
  },
  watch: {
    timevalue() {
      this.getPage();
    }
  }
};
</script>

<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.btn-box {
  display: flex;
  justify-content: flex-start;
}
</style>

<style lang="less">
.el-input--small .el-input__inner {
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/view/ParkingService/ParkingBill/ParkingMonthBill.vue